import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import isEmpty from 'lodash-es/isEmpty';
import isNumber from 'lodash-es/isNumber';
import isObject from 'lodash-es/isObject';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import Card from '@panneau/element-card';
import UrlField from '@panneau/field-url';

var _excluded = ["value", "schemes", "url", "disabled", "className", "onChange"];
var propTypes = {
  value: PropTypes.shape({
    url: PropTypes.string,
    metadata: PropTypes.shape({
      title: PropTypes.string,
      providerName: PropTypes.string,
      authorName: PropTypes.string,
      thumbnailUrl: PropTypes.string,
      description: PropTypes.string,
      duration: PropTypes.number,
      width: PropTypes.number,
      height: PropTypes.number
    })
  }),
  schemes: PropTypes.arrayOf(PropTypes.string),
  url: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps = {
  value: null,
  schemes: ['http://', 'https://', 'ftp://'],
  url: null,
  disabled: null,
  className: null,
  onChange: null
};
var EmbedField = function EmbedField(_ref) {
  var value = _ref.value;
    _ref.schemes;
    _ref.url;
    var disabled = _ref.disabled,
    className = _ref.className,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = isObject(value) ? value : {
      url: value
    },
    _ref2$url = _ref2.url,
    url = _ref2$url === void 0 ? null : _ref2$url,
    _ref2$metadata = _ref2.metadata,
    metadata = _ref2$metadata === void 0 ? null : _ref2$metadata;
  var urlValue = url || null;
  var _ref3 = metadata || {},
    _ref3$title = _ref3.title,
    title = _ref3$title === void 0 ? null : _ref3$title,
    _ref3$providerName = _ref3.providerName,
    providerName = _ref3$providerName === void 0 ? null : _ref3$providerName,
    _ref3$authorName = _ref3.authorName,
    authorName = _ref3$authorName === void 0 ? null : _ref3$authorName,
    _ref3$thumbnailUrl = _ref3.thumbnailUrl,
    thumbnailUrl = _ref3$thumbnailUrl === void 0 ? null : _ref3$thumbnailUrl,
    _ref3$description = _ref3.description,
    description = _ref3$description === void 0 ? null : _ref3$description,
    _ref3$duration = _ref3.duration,
    duration = _ref3$duration === void 0 ? null : _ref3$duration,
    _ref3$width = _ref3.width,
    width = _ref3$width === void 0 ? null : _ref3$width,
    _ref3$height = _ref3.height,
    height = _ref3$height === void 0 ? null : _ref3$height;
  var onFieldChange = useCallback(function (newValue) {
    if (onChange !== null) {
      onChange({
        url: newValue,
        metadata: null
      });
    }
  }, [onChange]);
  var onClose = useCallback(function () {
    onChange(null);
  }, [onChange]);
  var dateDuration = isNumber(duration) ? new Date(duration * 1000).toISOString().substr(11, 8) : null;
  return metadata !== null ? /*#__PURE__*/React.createElement(Card, {
    title: title,
    subtitle: providerName,
    image: thumbnailUrl,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-3"
  }, !isEmpty(authorName) ? /*#__PURE__*/React.createElement("p", {
    className: "fw-bold lh-1 mb-1"
  }, authorName) : null, !isEmpty(description) ? /*#__PURE__*/React.createElement("p", {
    className: "lh-1 mb-1"
  }, description) : null, !isEmpty(url) ? /*#__PURE__*/React.createElement("p", {
    className: "lh-1 mb-3"
  }, /*#__PURE__*/React.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, url)) : null, dateDuration !== null ? /*#__PURE__*/React.createElement("p", {
    className: "lh-1 mb-1"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "MHldGi",
    defaultMessage: [{
      "type": 0,
      "value": "Duration:"
    }]
  }), ' ', dateDuration) : null, width !== null && height !== null ? /*#__PURE__*/React.createElement("p", {
    className: "lh-1 mb-1"
  }, width, "x", height) : null)) : /*#__PURE__*/React.createElement(UrlField, Object.assign({}, props, {
    className: className,
    value: urlValue,
    onChange: onFieldChange,
    disabled: disabled
  }));
};
EmbedField.propTypes = propTypes;
EmbedField.defaultProps = defaultProps;

var definition = {
  id: 'embed',
  component: 'Embed'
};

export { EmbedField as default, definition };
